import { SxProps } from '@mui/material/styles'

export const getEditableFieldInputStyles = (isEditing?: boolean, hasError?: boolean): SxProps => {
  if (hasError) {
    return {}
  }

  if (isEditing) {
    return {
      '&:hover': {
        cursor: 'text',
      },
    }
  }

  return {
    '& .MuiInput-root': { boxShadow: 'none' },
  }
}
